import React, { useEffect, useState } from 'react';
import { ITransferChatOperatorItemProps } from "./~types/TransferChatOperatorItemProps";

import './TransferChatOperatorItem.css';
import { OperatorPriorityType } from 'src/app/chats-panel/~store/models/ChannelItem';
import { OperatorType } from 'src/app/chats-panel/~store/models/OperatorItem';
import { OperatorStatusType } from 'src/app/chats-panel/~store/state/ChatItemsState';
import { useTranslation } from 'react-i18next';
import { GET_FILE_BY_ID_API_ROUTE } from 'src/app/chats-panel/~api/apiRoutes';
import { FIRST_PAUSE_CATEGORY_ID, LAST_PAUSE_CATEGORY_ID } from 'src/app/chats-panel/~store/actions/ChatConstants';
import { ChannelOperatorPriority } from "src/app/channel/~store/models/enums/ChannelOperatorPriority";

const TransferChatOperatorItem = (props: ITransferChatOperatorItemProps) => {
    const { t } = useTranslation();

    const userInStorage = sessionStorage.getItem("user");
    const customerId = userInStorage === null ? "" : JSON.parse(userInStorage.toString()).customerId;
    
    const operatorAvatar = props.operator.avatarId === null ?
        require('src/app/shared/images/help.png') :
        GET_FILE_BY_ID_API_ROUTE + props.operator.avatarId;

    let operatorStatusText = t('common.offline');
    let operatorStatusValue = 'offline';

    let operatorStatusType = Number.parseInt(props.operatorStatus.toString());

    switch(operatorStatusType) {
        case OperatorStatusType.Offline.valueOf(): {
            operatorStatusText = t('common.offline');
            operatorStatusValue = 'offline';
            break;
        }
        case OperatorStatusType.Online.valueOf(): {
            operatorStatusText = t('common.online');
            operatorStatusValue = 'online';
            break;
        }
        case OperatorStatusType.Pause.valueOf(): {
            operatorStatusText = t('common.pause');
            operatorStatusValue = 'pause';
            break;
        }
        default: {
            if(props.operatorStatus >= FIRST_PAUSE_CATEGORY_ID || props.operatorStatus <= LAST_PAUSE_CATEGORY_ID) {
                operatorStatusText = props.pauseCategories[props.operatorStatus - FIRST_PAUSE_CATEGORY_ID];
                operatorStatusValue = 'pause';
            }
            
        }
    }

    const getTierDisplayText = (tier: ChannelOperatorPriority | undefined | null): string => {
        if (!tier) {
            return "";
        }
        if (tier === ChannelOperatorPriority.TierVIP) {
            return `, ${t("channels.vip")}`;
        }
        return `, ${t("common.tier")} ${tier}`;
    };

    const translatedOperatorType = (() => {
        switch (props.operator.type) {
            case OperatorType.Operator:
                return t('common.operator');
            case OperatorType.Bot:
                return t('common.bot');
            case OperatorType.Supervisor:
                return t('common.supervisor'); 
            default:
                return '';
        }
    })(); 
    
    return (
        <div className="transfer-chat__operator-item" tabIndex={0}
            onClick={() => props.onSelectOperator(props.operator.operatorId)}
            onKeyUp={(e) => {
                if (e.key === "Enter") {
                    props.onSelectOperator(props.operator.operatorId);
                }
            }}>
            <div className="transfer-chat__operator-item--avatar-container">
                <img
                    className={"operator-item__operator-avatar" + `  ${operatorStatusValue}`}
                    src={operatorAvatar}/>
            </div>
            <div className="operator-item__operator-info">
                <p>{props.operator.name}</p>
                <p>{t('common.chats') + ': ' + props.operator.openedChatsCount}</p>
                <p className={`operator-item__tier${props.tier ? "" : '-supervisor'}`}>
                    {`${translatedOperatorType}${getTierDisplayText(props.tier)}`}
                </p>
                <p className="operator-item__status-row">
                    <span className="operator-item__status-label">{t('common.status') + ": "}</span>
                    <span className={`operator-item__status operator-item__status-${operatorStatusValue}`}>{operatorStatusText}</span>
                </p>
            </div>
            {props.selected && <i className={"material-icons " + "operator-item__selected-icon"}>done</i>}
        </div>
    )
}

export default TransferChatOperatorItem;
